export enum SortOption {
  postedAtDesc = 'posted_at_desc',
  postedAtAsc = 'posted_at_asc',
  yearsOfExperienceDesc = 'years_of_experience_desc',
  yearsOfExperienceAsc = 'years_of_experience_asc',
  totalCompDesc = 'total_comp_desc',
  totalCompAsc = 'total_comp_asc',
  avgHoursPerWeekDesc = 'avg_hours_per_week_desc',
  avgHoursPerWeekAsc = 'avg_hours_per_week_asc',
}

export const USER_DEFAULT_SALARY_URL_COOKIE_NAME = 'userDefaultSalaryUrl'

/**
 * @param salaryId shows the salary details pane
 */
export enum SalaryFilterParam {
  jobType = 'jobType',
  page = 'page',
  salaryId = 'salaryId',
  location = 'location',
  occupation = 'occupation',
  payPeriod = 'payPeriod',
  sortBy = 'sortBy',
}

export enum SalaryFilterControl {
  profession = 'profession',
  specialty = 'specialty',
  state = 'state',
  payPeriod = 'payPeriod',
  jobType = 'jobType',
  page = 'page',
  sortBy = 'sortBy',
}

export const PLACEHOLDER_SALARY = '$100,000' // used when showing blurred salaries

export type ShowRowHintRow = { showRowHint: boolean }
